var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.items,"loading":!_vm.items,"dense":"","hide-default-footer":"","hide-default-header":""},scopedSlots:_vm._u([{key:"item.key",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.formatText(item.key))+" ")]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }